<template>
    <div>
     <v-row>
         <v-col cols="12">
            <mrx-translation token="questions.rdt_timer.instructions"></mrx-translation>
          </v-col>
         
          <v-col cols="12">
            <v-btn
              id="rdt-timer"
              block
              :disabled="!show"
              color="success"
              @click="click">
                <mrx-translation token="questions.rdt_timer.button"></mrx-translation>
            </v-btn>
          </v-col>
      </v-row>
     <rdt-timer></rdt-timer>
     </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        name: 'Timer',

        props: {
            'options': { type: Object, default: {} },
        },

        data() {
            return {}
        },
        computed: {
            show() {
                return this.$store.state.v4.rdt.status === 'aquiring' || this.$store.state.v4.rdt.status === 'timedout'
            }
        },
        methods: {
            click() {
                this.next()
            },
            ...mapActions({ next: 'v4/navigate/next' })
        }
    }
</script>
